import {
  HttpClient,
  HttpEvent,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { appointments, SideMenu, TestType } from '../models/appointments.model';

@Injectable({
  providedIn: 'root',
})
export class AppointmentService {
  testListUrl = '/appointment/testType';
  locationUrl = '/locations';
  sideMenu = '/menu';
  createAppointments = '/appointment/create';
  rescheduleAppointments = '/appointment/resheduleAppointment';
  reassignAppointment = '/appointment/reassignAppointment';
  updateClientUrl = '/appointment/update';
  user = '/user';
  userV2 = '/user/v2';
  appointments = '/appointment/view';
  appointmentsV2 = '/appointment/v2/view/all';
  appointmentsV3 = '/appointment/v3/view/all';
  followUpAppointmentsToBeSchedule =
    '/appointment/v2/view/followups-to-be-schedule';
  update = '/appointment';
  submitPayment = '/payment';
  schoolType = '/appointment/schoolType';
  saveUnavailability = '/user/saveUnavailabilityStatus';
  getDiagnosticianUnavailability = '/user/getUnavailabilityStatus';
  getOriginalDiagnosticianUnavailability =
    '/user/getOriginalUnavailabilityStatus';
  getTestsandSurveys = '/appointment/survey';
  findApptNotes = '/appointment/notes';
  findApptNotesV2 = '/appointment/notes/v2';
  createOrUpdateApptNotesUrl = '/appointment/notes/createOrUpdate';
  addNotesUrlV2 = '/appointment/notes/v2/create';
  updateNotesUrlV2 = '/appointment/notes/v2/update';
  saveSurvey = '/appointment/saveSurvey';
  dashboardDetails = '/dashboard/details';
  dashboardDetailsV2 = '/dashboard/v2/details';
  createFollowUp = '/appointment/followup';
  followupReschedule = '/appointment/followupReschedule';
  followupEdit = '/appointment/followupUpdate';
  saveObservationForm = '/observationForm/save';
  viewObservationForm = '/observationForm/viewForm';
  uploadAttachment = '/attachment/upload';
  fetchDocument = '/attachment/fetch';
  updateAssesmentTypeUrl = '/appointment/updateAssesmentType';
  receipt = '/receipt';
  resendClientBackgroundEmailUrl = '/resendClientBackgroundEmail';
  sendBackgroundFormReminderUrl = '/sendBackgroundFormReminder';

  constructor(private http: HttpClient) {}

  viewReceipt(apptId: any) {
    let params = new HttpParams();
    params = params.append('appointmentId', apptId);
    return this.http.get<any>(`${this.receipt}`, { params });
  }
  sendReceipt(details: any) {
    return this.http.post<any>(`${this.receipt}`, details);
  }

  getDocument(clientId: any) {
    let params = new HttpParams();
    params = params.append('clientId', clientId);

    return this.http.post<any>(`${this.fetchDocument}`, '', { params });
  }

  uploadDocument(clientId: any, file: any): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);
    formData.append('clientId', clientId);
    const req = new HttpRequest('POST', `${this.uploadAttachment}`, formData, {
      reportProgress: true,
      responseType: 'json',
    });

    return this.http.request(req);
  }

  // uploadDocument(clientId:any,file:any){
  //   const formData: FormData = new FormData();

  //   formData.append('file', file);
  //   formData.append('clientId', clientId);

  //   return this.http.post<any>(`${this.uploadAttachment}`,formData);
  // }

  getObservationForm(appointmentId: any) {
    let params = new HttpParams();
    params = params.append('appointmentId', appointmentId);

    return this.http.post<any>(`${this.viewObservationForm}`, '', { params });
  }
  submitObservationForm(request: any) {
    return this.http.post(`${this.saveObservationForm}`, request);
  }

  submitFollowUp(request: any) {
    return this.http.post(`${this.createFollowUp}`, request);
  }

  submitfollowupReschedule(request: any) {
    return this.http.post(`${this.followupReschedule}`, request);
  }
  submitfollowupEdit(request: any) {
    return this.http.post(`${this.followupEdit}`, request);
  }

  getTestTypes() {
    return this.http.get<TestType>(`${this.testListUrl}`);
  }

  getLocations() {
    return this.http.get(`${this.locationUrl}`);
  }
  getSideMenuDetails() {
    return this.http.get<SideMenu>(`${this.sideMenu}`);
  }

  getUser(location: any, userType: any) {
    let params = new HttpParams();
    if (location != null) {
      params = params.append('locationId', location);
    }
    if (userType != null) {
      params = params.append('userType', userType);
    }
    return this.http.get<any>(`${this.user}`, { params: params });
  }

  getUserV2(location: any, userType: any) {
    let params = new HttpParams();
    if (location != null) {
      params = params.append('locationId', location);
    }
    if (userType != null) {
      params = params.append('userType', userType);
    }
    return this.http.get<any>(`${this.userV2}`, { params: params });
  }

  getUserAll(location: any, userType: any) {
    let params = new HttpParams();
    if (location != null) {
      params = params.append('locationId', location);
    }
    if (userType != null) {
      params = params.append('userType', userType);
    }
    params = params.append('all', 1);
    return this.http.get<any>(`${this.user}`, { params: params });
  }

  createAppointment(appointmentDetails: any) {
    return this.http.post(`${this.createAppointments}`, appointmentDetails);

    // return this.htt
  }

  rescheduleAppointment(appointmentDetails: any) {
    return this.http.post(`${this.rescheduleAppointments}`, appointmentDetails);

    // return this.htt
  }

  reassignAppointmentMethod(appointmentDetails: any) {
    return this.http.post(`${this.reassignAppointment}`, appointmentDetails);

    // return this.htt
  }

  updateClient(appointmentDetails: any) {
    // console.log("updateClient");
    return this.http.post(`${this.updateClientUrl}`, appointmentDetails);

    // return this.htt
  }

  resendClientBackgroundEmail(apptId: any) {
    let params = new HttpParams();
    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }
    return this.http.get<any>(`${this.resendClientBackgroundEmailUrl}`, {
      params,
    });
  }

  sendBackgroundFormReminderEmail(apptId: any) {
    let params = new HttpParams();
    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }
    return this.http.get<any>(`${this.sendBackgroundFormReminderUrl}`, {
      params,
    });
  }

  updateUser(appointmentDetails: any) {
    // console.log("updateClient");
    return this.http.post(`${this.user}`, appointmentDetails);

    // return this.htt
  }

  getAppointments(
    location: any,
    diagnosticianId: any,
    status: any,
    apptId: any,
    fromDate: any,
    toDate: any
  ) {
    let params = new HttpParams();

    if (location != null) {
      params = params.append('locationId', location);
    }
    if (diagnosticianId != null) {
      params = params.append('diagnosticianId', diagnosticianId);
    }
    if (status != null) {
      params = params.append('status', status);
    }
    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }
    if (fromDate != null && fromDate.length > 0) {
      params = params.append('fromDate', fromDate);
    }
    if (toDate != null && toDate.length > 0) {
      params = params.append('toDate', toDate);
    }

    return this.http.get<any>(`${this.appointments}`, { params: params });
  }

  getAppointmentsV2(
    location: any,
    diagnosticianId: any,
    status: any,
    apptId: any,
    fromDate: any,
    toDate: any,
    scheduleType: any
  ) {
    let params = new HttpParams();

    if (location != null) {
      params = params.append('locationId', location);
    }
    if (diagnosticianId != null) {
      params = params.append('diagnosticianId', diagnosticianId);
    }
    if (status != null) {
      params = params.append('status', status);
    }
    if (scheduleType != null) {
      params = params.append('scheduleType', scheduleType);
    }
    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }
    if (fromDate != null && fromDate.length > 0) {
      params = params.append('fromDate', fromDate);
    }
    if (toDate != null && toDate.length > 0) {
      params = params.append('toDate', toDate);
    }

    return this.http.get<any>(`${this.appointmentsV2}`, { params: params });
  }

  getAppointmentsV3(
    location: any,
    diagnosticianId: any,
    status: any,
    apptId: any,
    fromDate: any,
    toDate: any,
    scheduleType: any
  ) {
    let params = new HttpParams();

    if (location != null) {
      params = params.append('locationId', location);
    }
    if (diagnosticianId != null) {
      params = params.append('diagnosticianId', diagnosticianId);
    }
    if (status != null) {
      params = params.append('status', status);
    }
    if (scheduleType != null) {
      params = params.append('scheduleType', scheduleType);
    }
    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }
    if (fromDate != null && fromDate.length > 0) {
      params = params.append('fromDate', fromDate);
    }
    if (toDate != null && toDate.length > 0) {
      params = params.append('toDate', toDate);
    }

    return this.http.get<any>(`${this.appointmentsV3}`, { params: params });
  }

  getFollowupAppointmentsToBeSchedule(
    location: any,
    diagnosticianId: any,
    status: any,
    apptId: any,
    scheduleType: any
  ) {
    let params = new HttpParams();
    if (location != null) {
      params = params.append('locationId', location);
    }
    if (diagnosticianId != null) {
      params = params.append('diagnosticianId', diagnosticianId);
    }
    if (status != null) {
      params = params.append('status', status);
    }
    if (scheduleType != null) {
      params = params.append('scheduleType', scheduleType);
    }
    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }
    return this.http.get<any>(`${this.followUpAppointmentsToBeSchedule}`, {
      params: params,
    });
  }

  updateAppts(status: any, apptId: any, comments: any, scheduleId: any) {
    let params = new HttpParams();

    if (status != null) {
      params = params.append('appointmentId', apptId);
    }
    if (apptId != null) {
      params = params.append('status', status);
    }
    if (comments != null) {
      params = params.append('comments', comments);
    }
    if (scheduleId != null) {
      params = params.append('scheduleId', scheduleId);
    }

    return this.http.put<any>(`${this.update}`, '', { params: params });
  }

  setDiagnosticianUnavailability(details: any) {
    return this.http.post(`${this.saveUnavailability}`, details);
  }

  getDiagUnavailability(resourceId: any, locationId: any, userType: any) {
    let params = new HttpParams();
    if (locationId != null) {
      params = params.append('locationId', locationId);
    }
    if (resourceId != null) {
      params = params.append('resourceId', resourceId);
    }
    if (userType != null) {
      params = params.append('userType', userType);
    }

    return this.http.get<any>(`${this.getDiagnosticianUnavailability}`, {
      params: params,
    });
  }

  getOriginalDiagUnavailability(
    resourceId: any,
    locationId: any,
    userType: any
  ) {
    let params = new HttpParams();
    if (locationId != null) {
      params = params.append('locationId', locationId);
    }
    if (resourceId != null) {
      params = params.append('resourceId', resourceId);
    }
    if (userType != null) {
      params = params.append('userType', userType);
    }

    return this.http.get<any>(
      `${this.getOriginalDiagnosticianUnavailability}`,
      { params: params }
    );
  }

  getSchoolType() {
    return this.http.get<appointments>(`${this.schoolType}`);
  }

  submitPaymentDetails(details: any, clientId: number, appointmentId: number) {
    let params = new HttpParams();
    params = params.append('clientId', clientId);
    params = params.append('appointmentId', appointmentId);

    return this.http.post(`${this.submitPayment}`, details, { params: params });
  }

  getTestsAndSuveys(apptId: any, scheduleId: any) {
    let params = new HttpParams();

    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }
    if (scheduleId != null) {
      params = params.append('scheduleId', scheduleId);
    }
    return this.http.get<any>(`${this.getTestsandSurveys}`, { params: params });
  }

  getApptNotes(apptId: any) {
    let params = new HttpParams();
    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }
    return this.http.get<any>(`${this.findApptNotes}`, { params: params });
  }

  getApptNotesV2(apptId: any) {
    let params = new HttpParams();
    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }
    return this.http.get<any>(`${this.findApptNotesV2}`, { params: params });
  }

  createOrUpdateApptNotes(requestBody: any) {
    return this.http.post<any>(
      `${this.createOrUpdateApptNotesUrl}`,
      requestBody
    );
  }

  addApptNotes(requestBody: any) {
    return this.http.post<any>(`${this.addNotesUrlV2}`, requestBody);
  }

  updateNotes(requestBody: any) {
    return this.http.post<any>(`${this.updateNotesUrlV2}`, requestBody);
  }

  saveSurveyDetails(surveyDetails: any) {
    return this.http.post(`${this.saveSurvey}`, surveyDetails);
  }

  getDashboardDetails(id: any) {
    let params = new HttpParams();
    if (id != null) {
      params = params.append('diagnosticianId', id);
    }
    return this.http.get<any>(`${this.dashboardDetails}`, { params: params });
  }

  getDashboardDetailsV2(id: any) {
    let params = new HttpParams();
    if (id != null) {
      params = params.append('diagnosticianId', id);
    }
    return this.http.get<any>(`${this.dashboardDetailsV2}`, { params: params });
  }

  updateAssesmentType(apptId: number, assesmentType: number) {
    let params = new HttpParams();

    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }
    if (assesmentType != null) {
      params = params.append('assesmentType', assesmentType);
    }
    return this.http.get<any>(`${this.updateAssesmentTypeUrl}`, {
      params: params,
    });
  }
}
